/* eslint-disable-next-line strict-null-checks/all */ /* Fix tracked by 5730662 */
declare const PACKAGE_VERSION: string;
export const version = PACKAGE_VERSION;
